var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AmxBeaconListener } from './drivers/framework/AmxBeaconListener';
import { Timeouts } from './drivers/framework/Timeouts';
export class AmxBeaconListenerServiceImpl {
    constructor(rootScope, kayleeService, roomService) {
        // TODO: We're waiting 30 seconds to make sure the network is up. We need to monitor the
        // network connection and start/restart the AMX beacon listener when the connection changes.
        this.isRunning = true;
        this.timeouts = new Timeouts();
        this.timeouts.delay(30000).then(() => __awaiter(this, void 0, void 0, function* () { return AmxBeaconListener.startListening(); }));
    }
}
